import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 sm:px-6 bg-brand-ivory text-center text-brand-text text-xs sm:text-sm border-t border-brand-border" data-id="element-69">
      <p className="leading-relaxed max-w-xl mx-auto font-medium mb-4" data-id="element-70">
        © 2026 GINNASTICA PRO™ — Tutti i Diritti Riservati.
        <br data-id="element-71" />
        <br data-id="element-72" />
        Le informazioni contenute in questo sito hanno esclusivamente finalità
        educative e rappresentano una risorsa professionale per allenatori e
        insegnanti di ginnastica artistica. Non sostituiscono il giudizio
        professionale dell'allenatore né le norme di sicurezza previste dalla
        società sportiva, dalla federazione o dagli enti competenti. Utilizza
        sempre la tua esperienza professionale e metti la sicurezza degli atleti
        al primo posto durante ogni allenamento.
      </p>
      <div className="flex justify-center gap-3 sm:gap-4 font-heading font-bold tracking-wide uppercase text-brand-navy" data-id="element-73">
        <a href="#" className="hover:text-brand-violet transition-colors" data-id="element-74">
          Termini e Condizioni
        </a>
        <span data-id="element-75">·</span>
        <a href="#" className="hover:text-brand-violet transition-colors" data-id="element-76">
          Privacy Policy
        </a>
        <span data-id="element-77">·</span>
        <a href="#" className="hover:text-brand-violet transition-colors" data-id="element-78">
          Contatti
        </a>
      </div>
    </footer>;
}